import { render, staticRenderFns } from "./ordonnances.html?vue&type=template&id=7860044e&scoped=true&external"
import script from "./ordonnances.js?vue&type=script&lang=js&external"
export * from "./ordonnances.js?vue&type=script&lang=js&external"
import style0 from "./ordonnances.scss?vue&type=style&index=0&id=7860044e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7860044e",
  null
  
)

export default component.exports